import React from 'react';
import { Platform, type ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';

import { pointerEventsStyles } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';

/**
 * This Gesture Handler is needed to prevent gestures
 * from withing the content interfering with the `Modal`.
 */
export const ModalWrapper = (props: ViewProps) => {
  const { children } = props;

  const { match } = useResponsive();

  const dialogWrapperStyles = [
    styles.dialogWrapper,
    match([styles.dialogWrapperMobile, styles.dialogWrapperTabletUp]),
  ];

  return (
    <GestureHandlerRootView style={[dialogWrapperStyles, pointerEventsStyles['box-none']]}>
      {children}
    </GestureHandlerRootView>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  dialogWrapper: {
    flexGrow: 1,

    // We use `maxHeight` to prevent content from overflowing the modal
    // on the web platform. That's not an issue on native platforms.
    maxHeight: Platform.select({
      web: '100%',
      default: undefined,
    }),
  },
  dialogWrapperMobile: {
    justifyContent: 'flex-end',
  },
  dialogWrapperTabletUp: {
    justifyContent: 'center',
  },
});
